import { render, staticRenderFns } from "./properties_label.vue?vue&type=template&id=5534d872&"
import script from "./properties_label.vue?vue&type=script&lang=js&"
export * from "./properties_label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports